import React from 'react';

import { useRouterLocation } from '#/components/hooks';
import HeaderMenuDropdown from '#/components/layout/header/HeaderMenuDropdown';
import DropdownMenuItem from '#/components/layout/header/HeaderMenuDropdownItem';
import {
  CommonItemProps,
  MenuItemType,
} from '#/components/layout/header/headerTypes';
import MenuLink from '#/components/layout/header/MenuLink';

export default function MenuItemRenderer({
  menuItem,
  linkProps,
}: {
  menuItem: MenuItemType;
  linkProps?: CommonItemProps['$linkProps'];
}) {
  const location = useRouterLocation();

  if (menuItem.Component) {
    return (
      // TODO: WTF there is no TS coverage at all for menuItem.Component (any)
      // This is either native dom element, Styled wrapper, or custom component
      <menuItem.Component
        $menuItem={menuItem}
        $location={location}
        $linkProps={linkProps}
      />
    );
  }

  switch (menuItem.type) {
    case 'DropdownMenuLink':
    case 'TopMenuLink':
    case 'MenuLink': {
      return (
        <MenuLink
          title={menuItem.label}
          to={menuItem.to}
          icon={menuItem.icon}
          isTradingIndex={menuItem.isTradingIndex}
          isTopMenu={menuItem.type === 'TopMenuLink'}
          isDropdownItem={menuItem.type === 'DropdownMenuLink'}
          paddingRight={menuItem.paddingRight}
          onClick={linkProps?.onClick}
          {...linkProps}
        />
      );
    }
    case 'MenuDropdown': {
      return (
        <DropdownMenuItem
          menuItem={menuItem}
          onHover={isHovered => {
            if (linkProps?.setDropdownOpen) {
              linkProps?.setDropdownOpen(isHovered);
            }
          }}
        />
      );
    }
    case 'MenuDropdownWithContentBox':
      return (
        <HeaderMenuDropdown
          label={menuItem.label}
          // disableDropdown={menuItem.disabled}
        >
          {menuItem.content()}
        </HeaderMenuDropdown>
      );
  }
  return null;
}
